<template>
  <div
    class="relative flex-shrink-0 w-80 bg-surface dark:bg-surface-dark rounded-lg self-start sticky top-4 max-h-[calc(100dvh-5.5rem)] flex flex-col"
    :class="{ 'border border-stroke dark:border-stroke-dark': !borderless }"
  >
    <!-- Omit `title` to drop this header row; the caller then renders its own name + close -->
    <div v-if="title" class="flex items-center justify-between px-4 pt-4 pb-0 flex-shrink-0">
      <div class="flex items-center gap-2 min-w-0">
        <slot name="title-prefix" />
        <h3 class="font-semibold text-fg-base dark:text-fg-base-dark text-sm truncate pr-2">{{ title }}</h3>
      </div>
      <button @click="$emit('close')" class="text-fg-faint hover:text-fg-secondary dark:hover:text-fg-base-dark text-lg leading-none flex-shrink-0">&times;</button>
    </div>

    <div class="flex-1 overflow-y-auto py-3 space-y-3 text-sm" :class="borderless ? 'px-0' : 'px-3'" v-scroll-autohide>
      <div v-if="saveError" class="px-3 py-2 text-xs rounded bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border border-red-200 dark:border-red-700">
        {{ saveError }}
      </div>
      <div v-if="saveSuccess" class="px-3 py-2 text-xs rounded bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-700">
        Saved.
      </div>
      <slot />
    </div>

    <div class="px-4 pb-4 pt-2 flex-shrink-0 border-t border-stroke dark:border-stroke-dark flex gap-2">
      <button
        v-if="showSave"
        @click="$emit('save')"
        :disabled="isSaving"
        class="flex-1 px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white text-sm font-medium transition-colors"
      >{{ isSaving ? 'Saving…' : 'Save' }}</button>
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title:       { type: String, default: '' },
  isSaving:    { type: Boolean, default: false },
  saveError:   { type: String, default: null },
  saveSuccess: { type: Boolean, default: false },
  showSave:    { type: Boolean, default: true },
  // Drop the panel's outline and side padding — with no edge to inset from, padding just
  // stacks on the host's gutter (ContactPanel's header card stands in for the outline).
  borderless:  { type: Boolean, default: false },
})
defineEmits(['close', 'save'])
</script>
